import React from 'react'
import Main from '../components/admin/Main'
import PageContainer from '../components/admin/PageContainer';

const Dashboard = () => {

  const authUser=JSON.parse(localStorage.getItem("VVRHCS"))
  return (
    <Main>
      <PageContainer>
        <h1>Welcome {authUser.username }!!</h1>
      </PageContainer>
      
    </Main>
  );
}

export default Dashboard